import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { GenericTable } from "../../../../../shared/components/GenericTable";
import { useConsumerListMissingPlan } from "../../hooks";

interface MissingPlansContentProps {
  billDraftId: string;
  data:any;
}
export const MissingPlansContent: React.FC<MissingPlansContentProps> = ({ billDraftId,data }) => {
    console.log("billDraftId in missing MissingPlansContent", billDraftId);

  const [missingPlanCurrentPage, setMissingPlanCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const params = useParams();
  const consumerMissingPlanColumns = [
    {
      key: "consumerNo",
      header: "Account Number",
    },
    {
      key: "consumerName", // Virtual key for combined name
      header: "Consumer Name",
      render: (value: any, row: any) => (
        <span className="font-medium">
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    
  ];

  // Define actions
  // const consumerActions = [
  //   {
  //     label: "Assign Plan",
  //     variant: "outline" as const,
  //     disabled: (row) => true,
  //     onClick: (row: any, index: number) => {
  //       console.log("Assigning plan for consumer:", row);
  //       handleAssignPlan(row);
  //     },
  //   },
  // ];

  // const { data: data } = useConsumerListMissingPlan(
  //   params?.id,
  //   billDraftId,
  //   missingPlanCurrentPage
  // );
  // console.log("data in MissingPlansContent",data);

  // Optional: Handle assign plan function
  const handleAssignPlan = (consumer: any) => {
    // Your assign plan logic here
    console.log("Assigning plan to:", consumer.consumer_no);
  };
  console.log("data.results in MissingPlansContent",data?.results);
  return (
    <>
      {
        <GenericTable
          data={data?.results ?? []}
          columns={consumerMissingPlanColumns}
          rowKey="id"
          // actions={consumerActions}
          actionsType="buttons"
          emptyMessage="No consumers without plans found"
          loading={false}
          pagination={{
            currentPage: missingPlanCurrentPage,
            totalPages: Math.ceil((data?.count || 0) / itemsPerPage),
            totalItems: data?.count || 0,
            itemsPerPage,
            startItem: (missingPlanCurrentPage - 1) * itemsPerPage + 1,
            endItem: Math.min(
              missingPlanCurrentPage * itemsPerPage,
              data?.count || 0
            ),
          }}
          onPageChange={setMissingPlanCurrentPage}
        />
      }
    </>
  );
};
